import React, { Fragment, useState, useContext } from "react";
import { AppHelper } from "../../App";
import ScrollTop from "../UI/ScrollTop";
import PostyJSON from "../../localization/posty.json";
import { LanguageContext } from "../../App";
import classes from "./DisplayPost.module.css";

import { Responsive } from "react-grid-layout";
import { WidthProvider } from "react-grid-layout";
import LocalizationJSON from "../../localization/localization.json";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";

const GridLayout = WidthProvider(Responsive);

function DisplayPost() {
  let langcontext = useContext(LanguageContext);
  let localizationJSON = LocalizationJSON;

  const postyJSON = PostyJSON;

  const returnMatch = (post) => {
    const urlPath = window.location.pathname;
    const postID = urlPath.slice(urlPath.lastIndexOf("/") + 1);
    if (post.id === postID) {
      return post;
    }
  };

  let currentPost = postyJSON.filter(returnMatch)[0];

  function RenderPost(currentPost) {
    let text;
    // let imgarr = [];
    let numberOfColumns = currentPost.layout;
    const imgarr = currentPost.content.map((current, i) => {
      if (current.type === "text") {
        text = AppHelper.ReturnLanguageContent(current, langcontext);
        return;
      }

      if (current.type === "img") {
        let imgpath;
        if (currentPost.layout === 1) {
          imgpath = `${AppHelper.storageUrl}media/posty/${currentPost.id}_${current.filename}.png`;
        } else {
          imgpath = `${AppHelper.storageUrl}media/posty/${currentPost.id}_${current.filename}_s.png`;
        }

        return (
          <div key={i}>
            <img
              className={classes.img}
              src={imgpath}
              alt={current.filename}
            ></img>
          </div>
        );
      }
    });

    let columnimagearray = [];
    for (let a = 0; a < numberOfColumns; a++) {
      let b = [];
      columnimagearray.push(b);
    }

    let initialarraylength = imgarr.length;
    let columncounter = numberOfColumns;

    function countColumn(a, b) {
      if (b === a) {
        columncounter = 1;
      } else {
        columncounter++;
      }
    }

    for (let c = 0; c < initialarraylength; c++) {
      columnimagearray[columncounter - 1].push(imgarr[0]);
      countColumn(numberOfColumns, columncounter);
      imgarr.shift();
    }

    return (
      <Fragment>
        <div className={classes.descriptiongrid}>
          <div className={classes.description}>
            {text}
            {RenderDownloadLink(currentPost.link)}
          </div>
        </div>

        {RenderImageColumn(columnimagearray, numberOfColumns)}
      </Fragment>
    );
  }

  //helper functions:

  const RenderDownloadLink = (link) => {
    if (link === undefined) {
      return <></>;
    } else {
      return (
        <div className={classes.download} onClick={() => downloadFile(link)}>
          {AppHelper.ReturnLanguageContent(
            localizationJSON.download,
            langcontext
          )}
        </div>
      );
    }
  };

  const downloadFile = async (link) => {
    let filePath = AppHelper.downloadUrl + link;
    try {
      const response = await fetch(filePath);
      const data = await response.blob();
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filePath.split("/").pop());
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error(error);
    }
  };

  const RenderImageColumn = (columnimagearray, numberOfColumns) => {
    let columnarray = [];
    for (let d = 0; d < numberOfColumns; d++) {
      columnarray.push(
        <div key={d} className={classes.imgcolumn}>
          {columnimagearray[d]}
        </div>
      );
    }

    return (
      <div
        className={`${classes.imagerow} ${checkNumberOfColumns(
          numberOfColumns
        )}`}
      >
        {columnarray}
      </div>
    );
  };

  const checkNumberOfColumns = (numberOfColumns) => {
    if (numberOfColumns === 1) {
      return classes.gridtemplatecolumn1;
    } else if (numberOfColumns === 2) {
      return classes.gridtemplatecolumn2;
    } else if (numberOfColumns === 3) {
      return classes.gridtemplatecolumn3;
    } else {
      return classes.gridtemplatecolumn4;
    }
  };

  /////////

  // const filteredImages = currentPost.content.filter(
  //   (obj) => obj.type === "img"
  // );

  // // console.log(filteredImages);
  // // console.log(filteredImages.length);

  // const originalLayouts = getFromLS("layouts") || {};

  // let state = {
  //   layouts: JSON.parse(JSON.stringify(originalLayouts)),
  // };

  // function getFromLS(key) {
  //   let ls = {};
  //   if (global.localStorage) {
  //     try {
  //       ls = JSON.parse(global.localStorage.getItem("rgl-8")) || {};
  //     } catch (e) {
  //       /*Ignore*/
  //     }
  //   }
  //   return ls[key];
  // }

  // function saveToLS(key, value) {
  //   if (global.localStorage) {
  //     global.localStorage.setItem(
  //       "rgl-8",
  //       JSON.stringify({
  //         [key]: value,
  //       })
  //     );
  //   }
  // }

  // function onLayoutChange(layout, layouts) {
  //   console.log("onlayoutchange");
  //   saveToLS("layouts", layouts);
  //   state.layouts = layouts;
  // }

  // function returnImagePath(img) {
  //   let imagepath = `${AppHelper.storageUrl}media/posty/${currentPost.id}_${img.filename}.png`;

  //   return imagepath;
  // }

  // let propsObject = Object.assign({
  //   cols: 12,
  //   rowHeight: 50,
  //   width: 1200,
  //   breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  //   cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  //   compactType: null,
  //   layouts: state.layouts,
  //   margin: [0, 0],
  //   onLayoutChange: onLayoutChange,
  //   useCSSTransforms: true,
  //   isDroppable: false,
  //   isResizable: true,
  //   resizeHandles: ["se"],
  // });

  return (
    <Fragment>
      {/* <GridLayout className={classes.gridlayout} {...propsObject}>
        {filteredImages.map((image) => (
          <div
            className={`${classes.griddiv} `}
            key={image.imgnumber}
            onClick={() => returnImagePath(image)}
          >
            <img
              className={classes.gridimg}
              src={returnImagePath(image)}
              alt={image.filename}
            ></img>
          </div>
        ))}
      </GridLayout> */}

      <div className={classes.main}>{RenderPost(currentPost)}</div>
      <div className={classes.bottombox}></div>
      <ScrollTop></ScrollTop>
    </Fragment>
  );
}

export default DisplayPost;
